import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IJobAssemblySessionResponse } from "../models/Job";
import {
  FinishTriageSessionRequest,
  PauseTriageSessionRequest,
  StartTriageSessionRequest,
} from "../models/Triage";

export default function useTriageSession(triageId?: string) {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const sessions = useQuery({
    queryKey: ["triageSessions", triageId],
    queryFn: () => get<IJobAssemblySessionResponse>(`/JobAssemblySession/triage/${triageId}`),
    enabled: !!triageId,
  });

  const invalidate = () => {
    queryClient.invalidateQueries(["triageSessions", triageId]);
    queryClient.invalidateQueries(["triage", triageId]);
  };

  const startSession = useMutation(
    (body: StartTriageSessionRequest) => post("/JobAssemblySession/triage/start", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  const pauseSession = useMutation(
    (body: PauseTriageSessionRequest) => post("/JobAssemblySession/triage/pause", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  const finishSession = useMutation(
    (body: FinishTriageSessionRequest) => post("/JobAssemblySession/triage/finish", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  return {
    sessions,
    startSession,
    pauseSession,
    finishSession
  };
}
